goog.provide('el8.appchart.dialog.ordermed.txStartDate');

goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.template.appchart.dialog.ordermed.txStartDate');
goog.require('el8.template.ptdata.model.medOrderThread');
goog.require('el8.uiwidget.alert');
goog.require('el8.appchart.medsMgr');
goog.require('el8.ptdata.medOrderThreads');
goog.require('el8.util.validate');


el8.appchart.dialog.ordermed.txStartDate = (function() {

    var _currThread = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Set Treatment Start Date',
        autoHeight: true,
        width: 400,
        contentFn: el8.template.appchart.dialog.ordermed.txStartDate.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'startDate',
                type: 'input',
                selector: ':input[name="startDate"]',
                datePickerOpts: {},
                validate: {
                    required: true,
                    validDate: true,
                    todayOrBefore: true
                }
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });
    form.addSaveButton(function(_form) {
        if (!_form.isValid()) {
            el8.uiwidget.alert('Please enter a start date that is today or earlier.');
            return;
        }
        var startDate = _form.getVal('startDate');
        el8.appchart.medsMgr.changeThreadStartDate(
            _currThread.getId(), startDate, function() { that.hide(); }
        );
    });
    form.addDiscardChangesButton(function() {
        that.hide();
    });
    that.setForm(form);

    var super_show = that.show;
    that.show = function(threadId) {
        super_show.call(that);
        _currThread = el8.ptdata.medOrderThreads.getById(threadId);
        form.setVal('startDate', _currThread.getStartDate().asString());

        // Set the med-info div
        $('#med-thread-start-date-med-info', that.getContentElt()).html(
            el8.template.ptdata.model.medOrderThread.summary(_currThread.asSoyMap()));
        
        that.adjustHeight();
    };

    return that;

})();


